import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import useFetchQlp96WellMetrics from '../Hooks/qlp_ddpcr/useFetchQlp96WellMetrics';

import SelectDropDown from '../common/ReactHookForm/SelectDropDown';
import { statisticDataSettings } from '../constants/statisticSettings';
import "./PlateWell.css";
import { usePlateWellActions, useSelectedValue } from '../../store/plateWellStore';
import { extractWellValues, formatWellValues, processWellDataForSelection, processPlateDataForSelction } from './PlateDataWrangling';
import RenderChannelData from '../common/Renderers/ChannelData';

const PlateEdit = () => {

    const { setDropDownSelectedData, setChannelData, setPlateDropDownSelectedData, setSelectedValue } = usePlateWellActions();

    const { plate_uuid } = useParams();
    const { data, isSuccess } = useFetchQlp96WellMetrics(plate_uuid);
    const storedSelectedValue = useSelectedValue();

    //plate_uuid is passed in from Qlp96WellMetricsList.jsx
    const channels = isSuccess ? data?.data[0] : [];
    const wellValues = isSuccess ? extractWellValues(data?.data, statisticDataSettings) : {};

    const plateValues = isSuccess ? data?.data[2] : {};
    const formattedWellValues = formatWellValues(wellValues, channels);
    const plateData = plateValues && new Map(Object.entries(plateValues));// data[2] is all plate value


    const handleSelect = (e) => {


        const selectedValue = e.target.value;
        setSelectedValue(selectedValue);
        setChannelData(channels);
        const plateDataForSelection = processPlateDataForSelction(plateData, selectedValue);
        setPlateDropDownSelectedData(plateDataForSelection);
        const welldataForSelection = processWellDataForSelection(formattedWellValues, selectedValue, channels);
        setDropDownSelectedData(welldataForSelection);
    }

    useEffect(() => {
        const initialSelection = statisticDataSettings[0].value;//set this as initial state of the page

        setChannelData(channels);
        const plateDataForSelection = processPlateDataForSelction(plateData, storedSelectedValue ? storedSelectedValue : initialSelection);
        setPlateDropDownSelectedData(plateDataForSelection);
        const welldataForInitialSelection = processWellDataForSelection(formattedWellValues, storedSelectedValue ? storedSelectedValue : initialSelection, channels);
        setDropDownSelectedData(welldataForInitialSelection);
    }, [data])

    return (


        <div className='plate-edit-setup'>
            <h4 className='font-bold pb-4'> Plate Setup </h4>
            <RenderChannelData />
            <h4 className='font-bold pt-4 pb-4'> Statistics Overlay </h4>
            <SelectDropDown className='selectDropDown border border-gray-300 px-4 py-2 rounded-md font-bold'
                options={statisticDataSettings} defaultValue={storedSelectedValue ? storedSelectedValue : statisticDataSettings[0].value} name="Statistic Settings"
                onChange={handleSelect} />
            <h4 className='font-bold pt-4 pb-4'> Metrics Help </h4>
            <Link className='font-bold text-blue-300 hover:text-blue-700 underline' to='/display/documentation/qlp_metrics/'>Well</Link>
        </div >

    )




}

export default PlateEdit;
